/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
export const gmaoInputCheckboxComponent = {
    template: require('./gmao-input-checkbox.html'),
    bindings: {
        model: '=',
        modelOptions: '<',
        validationError: '<',
        disabled: '<',
        readonly: '<',
        label: '<',
        labelKey: '<',
        hintKey: '<'
    }
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/component/GmaoInputCheckbox.js